import React, { useState, useEffect } from "react"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import toast from "react-hot-toast"
import Select from "react-select"
import { Select as SearchBox } from "antd"
// api
import { getAllBranches } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"

// assets & styles
import {
  numberFormat,
  refreshPage,
  toastStyle,
  formatYDM,
  antdesignSelectStyle,
} from "../../../Helpers/Utils/Common"
import trash from "./../../../Assets/Images/trash.png"
import Navbar from "../../../Components/Navbar/Navbar"
import { Fragment } from "react"
import {
  getSingleSalesInvoice,
  updateSalesInvoice,
  getAllSaleItemsByBranch,
} from "../../../Helpers/apiCalls/franchiseeApi"
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi"
import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi"
import { validateFranchiseSale } from "../../../Helpers/Validation/Franchise/FranchiseSaleValidation"
import InputError from "../../../Components/InputError/InputError"
import ReactLoading from "react-loading"
import {
  createSalesQuotation,
  getSalesQuotation,
  updateSalesQuotation,
} from "../../../Helpers/apiCalls/SalesModule/SalesQuotationApi"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import Footer from "../../../Components/Footer/Footer"
import {
  validateSalesItems,
  validateSalesQuotation,
} from "../../../Helpers/Validation/Sales/SalesValidation"
import { getItemPriceByBranch } from "../../../Helpers/apiCalls/Manage/ItemPrice"

function SalesQuotationForm({ add, edit }) {
  const { id } = useParams()
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  const [isChanged, setIsChanged] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const currentDate = Date()
  const [addDetails, setAddDetails] = useState({
    delivery_fee: 0,
    service_fee: 0,
    delivery_date: formatYDM(currentDate),
    valid_from: formatYDM(currentDate),
    valid_to: formatYDM(currentDate),
    address: "",
    contact_no: "",
    branch_id_value: "",
    customer_id: "",
  })
  const [orderItems, setOrderItems] = useState([])

  // DATA HANDLERS
  const [customers, setCustomers] = useState([])
  const [branches, setBranches] = useState([])
  const [allItems, setAllItems] = useState([])
  const [filteredItems, setFilteredItems] = useState([])
  const [prices, setPrices] = useState([])

  //ERROR HANDLING
  const [itemError, setItemError] = useState({})
  const [isError, setIsError] = useState({
    franchisee_id: false,
    address: false,
    delivery_date: false,
    seller_branch_id: false,
    sales_invoice_no: false,
    list: false,
    item_id: false,
    qty: false,
    qty2: false,
    invoice_no: false,
    valid_to: false,
    valid_from: false,
  })
  function handleSelectChange(e, type) {
    if (type === "customer") {
      setAddDetails((prevAddDetails) => ({
        ...prevAddDetails,
        [e.name]: e.value,
        [e.value_variable]: {
          label: e.label,
          value: e.value,
          name: e.name,
        },
        address: e.trade_address, // Include trade address
        contact_no: e.phone_no, // Include contact number
        branch_id_value: e.branch_id,
      }))
    } else {
      setAddDetails((prevAddDetails) => ({
        ...prevAddDetails,
        [e.name]: e.value,
        [e.value_variable]: {
          label: e.label,
          value: e.value,
          name: e.name,
        },
      }))
    }
  }

  function handleAddChange(e) {
    const newList = { ...addDetails }
    const { name, value } = e.target
    newList[name] = value
    if (name === "service_fee" || name === "delivery_fee") {
      setIsChanged(!isChanged)
    }
    setAddDetails(newList)
  }

  /**
   *  ORDER ITEMS
   */
  function addNewOrder() {
    const newItem = {
      qty: "1",
      unit: "",
      name: "",
      item_id: "",
      priceValue: "",
      price: "0.00",
      unit_discount: "0.00",
      total: "0.00",
      subtotal: "0.00",
      discount: 0,
      // item_id_value: {
      //     label:"",
      //     value:"",
      // }
    }
    setOrderItems((oldItems) => [...oldItems, newItem])
  }
  function deleteOrder(row) {
    setIsChanged(true)

    const updatedOrderList = [...orderItems]
    updatedOrderList.splice(row, 1)
    setOrderItems(updatedOrderList)

    const filteredOptions = allItems.filter((option) => {
      return !updatedOrderList.find((item) => item.item_id === option.item_id)
    })
    setFilteredItems(filteredOptions)

    setTimeout(() => setIsChanged(false), 10)
  }

  function handleOrderItemsChange(e, row, type) {
    console.log(e)
    console.log(row)
    console.log(type)
    setIsChanged(true)
    var temp = orderItems
    if (type === "item_id") {
      var item_name = allItems.filter((data) => {
        return data.value === e
      })
      temp[row].is_old_item = false
      temp[row].item_id = item_name[0].value
      temp[row].item_name = item_name[0].item_name
      temp[row].item_id_value = {
        label: item_name[0].label,
        value: item_name[0].value,
      }
      temp[row].qty = 1
      temp[row].unit = item_name[0].item_units[0]?.unit_from
      temp[row].item_unit_id = item_name[0].item_units[0]?.id
      temp[row].unit_value =
        item_name[0].item_units[0]?.unit_from +
        "|" +
        item_name[0].item_units[0]?.id
      temp[row].name = null
      temp[row].current_qty = item_name[0].current_qty
      temp[row].item_units = item_name[0].item_units
      temp[row].item_code = item_name[0].item_code

      const prices = []

      temp[row].has_item_price =
        item_name[0].has_item_price === 1 ? true : false
      temp[row].price =
        item_name[0].has_item_price === 1
          ? item_name[0].item_units[0]?.wholesale_price
          : 0

      // temp[row].discount = {
      //   label: item_name[0].item_units[0]?.wholesale_price,
      //   value: item_name[0].item_units[0]?.wholesale_price,
      // }
      item_name[0].item_units.map((data) => {
        if (
          data.wholesale_price !== null &&
          data.wholesale_price !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.wholesale_price,
            value: data.wholesale_price,
          })
        }
        if (data.retail_price !== null && data.retail_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.retail_price,
            value: data.retail_price,
          })
        }
        if (
          data.special_price_1 !== null &&
          data.special_price_1 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_1,
            value: data.special_price_1,
          })
        }
        if (
          data.special_price_2 !== null &&
          data.special_price_2 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_2,
            value: data.special_price_2,
          })
        }
        if (
          data.special_price_3 !== null &&
          data.special_price_3 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_3,
            value: data.special_price_3,
          })
        }
        if (data.cost_price !== null && data.cost_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.cost_price,
            value: data.cost_price,
          })
        }
        // save the item prices in each item array
        temp[row].item_prices = prices
        // setPrices(prices);
      })
      var subtotal =
        temp[row].qty && temp[row].price
          ? parseFloat(
              parseInt(temp[row].qty) * parseFloat(temp[row].price)
            ).toString()
          : "0.00"
      temp[row].exceed = false
      if (temp[row].unit_discount) {
        temp[row].subtotal = (
          parseFloat(subtotal) - parseFloat(temp[row].unit_discount)
        ).toString()
      } else {
        temp[row].subtotal = subtotal
      }
      const filteredOptions = allItems.filter((option) => {
        return !temp.find((item) => item.item_id === option.item_id)
      })
      setFilteredItems(filteredOptions)
    } else if (type === "prices") {
      // changes for price
      temp[row].priceValue = { label: e, value: e }
      temp[row].price = e

      if (parseInt(temp[row].qty) > parseInt(temp[row].current_qty)) {
        toast.error("Quantity exceeds current inventory quantity.", {
          style: toastStyle(),
        })
        toast.error(
          temp[row].item_name + " current quantity: " + temp[row].current_qty,
          {
            style: toastStyle(),
          }
        )
        // setExceed(true);
        var subtotal =
          temp[row].qty && temp[row].price
            ? parseFloat(
                parseInt(temp[row].qty) * parseFloat(temp[row].price)
              ).toString()
            : "0.00"
        temp[row].exceed = true
        if (temp[row].unit_discount) {
          temp[row].subtotal = (
            parseFloat(subtotal) - parseFloat(temp[row].unit_discount)
          ).toString()
        } else {
          temp[row].subtotal = subtotal
        }
        // setExceed(true);
      } else {
        var subtotal =
          temp[row].qty && temp[row].price
            ? parseFloat(
                parseInt(temp[row].qty) * parseFloat(temp[row].price)
              ).toString()
            : "0.00"
        temp[row].exceed = false
        if (temp[row].unit_discount) {
          temp[row].subtotal = (
            parseFloat(subtotal) - parseFloat(temp[row].unit_discount)
          ).toString()
        } else {
          temp[row].subtotal = subtotal
        }
        // setExceed(false);
      }
    } else {
      const { name, value } = e.target
      temp[row][name] = value
      if (
        name === "qty" ||
        name === "price" ||
        name === "unit_discount" ||
        name === "discount"
      ) {
        if (parseInt(temp[row].qty) > parseInt(temp[row].current_qty)) {
          toast.error("Quantity exceeds current inventory quantity.", {
            style: toastStyle(),
          })
          toast.error(
            temp[row].item_name + " current quantity: " + temp[row].current_qty,
            {
              style: toastStyle(),
            }
          )
          // setExceed(true);
          var tempSubtotal =
            temp[row].qty && temp[row].price
              ? parseFloat(
                  parseInt(temp[row].qty) * parseFloat(temp[row].price)
                ).toString()
              : "0.00"
          temp[row].exceed = true
          if (temp[row].unit_discount) {
            temp[row].subtotal = (
              parseFloat(tempSubtotal) - parseFloat(temp[row].unit_discount)
            ).toString()
          } else {
            temp[row].subtotal = tempSubtotal
          }
          // setExceed(true);
        } else {
          var tempTotal =
            temp[row].qty && temp[row].price
              ? parseFloat(
                  parseInt(temp[row].qty) * parseFloat(temp[row].price)
                ).toString()
              : "0.00"
          temp[row].exceed = false
          if (temp[row].discount) {
            temp[row].subtotal = parseFloat(tempTotal)
            var tempDiscount =
              tempTotal * (parseFloat(temp[row].discount) / 100)
            temp[row].subtotal = (
              parseFloat(tempTotal) - tempDiscount
            ).toString()
            temp[row].discount_amount = tempDiscount
          } else {
            temp[row].subtotal = tempTotal
            temp[row].discount_amount = 0
          }
          // setExceed(false);
        }
      }
      if (name === "unit") {
        temp[row].unit = value.split("|")[0]
        temp[row].item_unit_id = value.split("|")[1]
        temp[row].unit_value = value
        // var itemInfo = allItems?.filter(
        //     (info) => info.id === temp[row].item_id
        // );
        // var unitInfo = itemInfo[0]?.item_units?.filter(
        //     (info) => info.unit_to === value
        // );
        // temp[row].price = unitInfo ? unitInfo[0]?.previous_item_prices : 0;
      }
    }
    setOrderItems(temp)
    setTimeout(() => setIsChanged(false), 1)
  }

  console.log(orderItems)
  async function handleSubmitInvoice() {
    var errors = validateSalesItems(orderItems)
    setItemError(errors)
    if (
      validateSalesQuotation(addDetails, orderItems, setIsError) &&
      Object.keys(errors).length === 0
    ) {
      setIsClicked(true)
      addDetails.status = "pending"
      const response = await createSalesQuotation(addDetails, orderItems)
      if (response.data) {
        toast.success("Successfully created order request", {
          style: toastStyle(),
        })
        setTimeout(() => navigate("/salesquotation"), 1000)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error(
        "Please fill in all fields and check if order quantity is greater than 0",
        { style: toastStyle() }
      )
    }
  }

  async function handleUpdatePI() {
    var errors = validateSalesItems(orderItems)
    setItemError(errors)
    if (
      validateSalesQuotation(addDetails, orderItems, setIsError) &&
      Object.keys(errors).length === 0
    ) {
      setIsClicked(true)
      const response = await updateSalesQuotation(addDetails, orderItems)
      if (response.data) {
        toast.success("Successfully updated sales invoice", {
          style: toastStyle(),
        })
        setTimeout(() => navigate("/salesquotation/print/" + id), 1000)
      } else if (response.error) {
        toast.error("Error updating sales invoice", {
          style: toastStyle(),
        })
        setIsClicked(false)
      }
      setIsClicked(false)
    } else {
      toast.error(
        "Please fill in all fields and check if order quantity is greater than 0",
        { style: toastStyle() }
      )
    }
  }

  //

  const handleSubmit = () => {
    if (add) handleSubmitInvoice()
    else if (edit) handleUpdatePI()
  }

  /** FOR EDIT - Fetch Sales Invoice Details */
  async function fetchSalesQuotation() {
    const response = await getSalesQuotation({ id: id })
    if (response.data) {
      var data = response.data.data[0]
      data.branch_id_value = {
        label: data.branch_name,
        value: data.branch_id,
      }

      data.customer_id_value = {
        label: data.customer_name,
        value: data.customer_id,
      }

      var ordered_items = data.sales_quotation_items.map((item) => {
        var info = item
        info.value = item.item_id
        info.subtotal = item.subtotal
        info.item_id_value = { label: item.item_name, value: item.item_id }
        info.priceValue = { label: item.price, value: item.price }
        info.unit_value = item.unit + "|" + item.item_unit_id
        info.is_old_item = true
        info.service_fee = item.service_fee
        info.discount_amount = item.price * item.qty - item.subtotal
        return info
      })
      setOrderItems(ordered_items)

      // to fetch items and set the filtered items
      // fetchItemsByBranch(addDetails.branch_id, ordered_items);

      var _subtotal = ordered_items
        .map((item) => parseFloat(item.subtotal))
        .reduce((a, b) => a + b, 0)

      data.subtotal = _subtotal

      setAddDetails(data)
    }
  }

  console.log(orderItems)

  // FOR EDIT - to filter item options and set unit dropdown values and prices per item
  function handleSetItemUnitOption(items, item_options) {
    var itemList = items?.map((item) => {
      var info = item
      var units = item_options?.filter((data) => data.value === item.value)
      info.item_units = units[0]?.item_units
      var prices = []
      units[0]?.item_units.map((data) => {
        if (
          data.wholesale_price !== null &&
          data.wholesale_price !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.wholesale_price,
            value: data.wholesale_price,
          })
        }
        if (data.retail_price !== null && data.retail_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.retail_price,
            value: data.retail_price,
          })
        }
        if (
          data.special_price_1 !== null &&
          data.special_price_1 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_1,
            value: data.special_price_1,
          })
        }
        if (
          data.special_price_2 !== null &&
          data.special_price_2 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_2,
            value: data.special_price_2,
          })
        }
        if (
          data.special_price_3 !== null &&
          data.special_price_3 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_3,
            value: data.special_price_3,
          })
        }
        if (data.cost_price !== null && data.cost_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.cost_price,
            value: data.cost_price,
          })
        }
        // save the item prices in each item array
        info.item_prices = prices
        // setPrices(prices);
      })

      return info
    })

    setOrderItems(itemList)

    const filteredOptions = item_options.filter((option) => {
      return !items.find((item) => item.item_id === option.item_id)
    })
    setFilteredItems(filteredOptions)
  }

  async function fetchBranches() {
    setBranches([])
    const response = await getAllBranches()

    if (response.data) {
      let result = response.data.data.map((a) => {
        var info = {}
        info.name = "branch_id"
        info.label = a.name
        info.value = a.id
        info.value_variable = "branch_id_value"
        return info
      })
      setBranches(result)
    }
  }

  async function fetchCustomers() {
    setCustomers([])
    const response = await getCustomer({})
    if (response.data) {
      var customers = response.data.data.sort((a, b) =>
        a.trade_name > b.trade_name ? 1 : b.trade_name > a.trade_name ? -1 : 0
      )

      var cleanedArray = customers.map((customer) => {
        var info = {
          ...customer,
          id: customer.id,
          name: "customer_id",
          label: customer.trade_name,
          value: customer.id,
          value_variable: "customer_id_value",
        }

        return info
      })
      setCustomers(cleanedArray)
    }
  }

  const handleSearchItem = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setAllItems)
    }
  }

  // new api for searching items
  async function handleFetchItems(value, setAllItems) {
    setAllItems([])
    const response = await getItemPriceByBranch({
      name: value,
      branch_id: addDetails.branch_id,
    })
    if (response.data) {
      var itemsList = response.data.data.map((data) => {
        var info = data
        info.label = data.item_name
        info.value = data.item_id
        info.name = "item_id"
        info.item_name = data.item_name
        // item_unit_id= data.item_unit_id
        info.item_id = data.item_id
        info.unit = data.unit
        info.wholesale_price = data.wholesale_price
        info.retail_price = data.retail_price
        info.special_price_1 = data.special_price_1
        info.special_price_2 = data.special_price_2
        info.special_price_3 = data.special_price_3
        info.cost_price = data.cost_price
        info.current_qty = data.current_qty
        info.item_code = data.item_code
        info.item_units = data.item_units
        info.discount = data.discount

        return info
      })
      setAllItems(itemsList)
    } else {
      response.error?.data?.messages.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }
  async function fetchItemsByBranch(branch_id, ordered_items) {
    setAllItems([])
    setFilteredItems([])
    const response = await getItemPriceByBranch(branch_id)
    // const response = await getAllSaleItemsByBranch(branch_id);

    if (response.data) {
      var data = response.data.data
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        .map((data, i) => {
          return {
            label: data.item_name,
            value: data.item_id,
            name: "item_id",
            item_name: data.item_name,
            // item_unit_id: data.item_unit_id,
            item_id: data.item_id,
            unit: data.unit,
            wholesale_price: data.wholesale_price,
            retail_price: data.retail_price,
            special_price_1: data.special_price_1,
            special_price_2: data.special_price_2,
            special_price_3: data.special_price_3,
            cost_price: data.cost_price,
            current_qty: data.current_qty,
            item_units: data.item_units,
          }
        })
      setAllItems(data)
      if (edit) {
        // const filteredOptions = data?.filter(option => {
        //     return !ordered_items.find(item => item?.item_id === option.item_id);
        // });
        // setFilteredItems(filteredOptions);
        handleSetItemUnitOption(ordered_items, data)
      } else {
        setFilteredItems(data)
      }
    }
  }

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  // DATA FETCHING
  useEffect(() => {
    if (edit) {
      fetchSalesQuotation()
    }
    fetchBranches()
    fetchCustomers()
  }, [])

  // useEffect(() => {
  //     if(add) {
  //         fetchItemsByBranch(addDetails.branch_id, []);
  //     }
  // }, [addDetails.branch_id]);

  // FOR DYNAMIC CALCULATION
  useEffect(() => {
    var tempServiceFee = addDetails.service_fee
      ? parseFloat(addDetails.service_fee)
      : 0
    var tempDeliveryFee = addDetails.delivery_fee
      ? parseFloat(addDetails.delivery_fee)
      : 0

    var _subtotal = orderItems
      .map((item) => parseFloat(item.subtotal))
      .reduce((a, b) => a + b, 0)

    // var _subtotal2 = additionalItemList
    //     .map((item) => parseFloat(item.total))
    //     .reduce((a, b) => a + b, 0);

    var _grandTotal = _subtotal + tempServiceFee + tempDeliveryFee
    setAddDetails((prev) => {
      return {
        ...prev,
        subtotal: _subtotal.toFixed(2),
        grand_total: _grandTotal.toFixed(2),
      }
    })
  }, [isChanged])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WHOLESALE"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {add ? "ADD SALES QUOTATION" : "EDIT SALES QUOTATION"}
            </h1>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          {/* FRANCHISEE SALES INVOICE DETAILS */}
          <Fragment>
            <Row className="mb-4">
              <Col xs={12} lg={4}>
                <span className="edit-label">
                  Customer
                  <span className="color-red"> *</span>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Customer..."
                  value={addDetails.customer_id_value}
                  options={customers}
                  onChange={(e) => handleSelectChange(e, "customer")}
                />
                <InputError
                  isValid={isError.customer_id}
                  message={"Branch is required"}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Branch
                  <span className="color-red"> *</span>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Branch..."
                  value={addDetails.branch_id_value}
                  // value={branches.length > 0 ? branches[0] : null}
                  options={branches}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.branch_id}
                  message={"Branch is required"}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Delivery Date
                  <span className="color-red"> *</span>
                </span>
                <Form.Control
                  type="date"
                  name="delivery_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.delivery_date}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.delivery_date}
                  message={"Branch is required"}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} lg={6}>
                <span className="edit-label">
                  Delivery Address
                  <span className="color-red"> *</span>
                </span>
                <Form.Control
                  type="text"
                  name="address"
                  value={addDetails.address}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.address}
                  message={"Franchisee Branch is required"}
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                <span className="edit-label">Valid From</span>
                <span className="color-red"> *</span>
                <Form.Control
                  type="date"
                  name="valid_from"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.valid_from}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.valid_from}
                  message={"Valid From is required"}
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Valid To
                  <span className="color-red"> *</span>
                </span>
                <Form.Control
                  type="date"
                  name="valid_to"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.valid_to}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.valid_to}
                  message={"Valid To is required"}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} lg={6}>
                <span className="edit-label">Contact No.</span>
                <span className="color-red"> *</span>
                <Form.Control
                  type="text"
                  name="contact_no"
                  value={addDetails.contact_no}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.contact_no}
                  message={"Franchisee Branch is required"}
                />
              </Col>
              <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Ship Via
                  <span className="color-red"> *</span>
                </span>
                <select
                  className="nc-modal-custom-select"
                  name="ship_via"
                  value={addDetails.ship_via}
                  onChange={(e) => handleAddChange(e)}
                >
                  <option value="">Select...</option>
                  <option value="pick_up">Pick Up</option>
                  <option value="delivery">Delivery</option>
                </select>
                <InputError
                  isValid={isError.ship_via}
                  message={"Ship Via is required"}
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <span className="edit-label">Remarks</span>
              <Col xs={12} lg={12}>
                <Form.Control
                  type="textarea"
                  name="remarks"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.remarks}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
          </Fragment>

          {/* ORDER ITEMS */}
          <Row>
            <Col>
              <span className="edit-label mb-2">
                Choose Items to Order
                <span className="color-red"> *</span>
              </span>
              <div className="edit-purchased-items">
                {orderItems.length !== 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <th className="color-gray">item</th>
                        <th className="color-gray">code</th>
                        <th className="color-gray">quantity</th>
                        <th className="color-gray">unit</th>
                        <th className="color-gray">price</th>
                        <th className="color-gray">discount</th>
                        <th className="color-gray">total</th>
                        <th className="color-gray">remarks</th>
                        <th className="color-gray">actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderItems.map((item, index) => {
                        return (
                          <tr>
                            <td>
                              <Form.Control
                                type="text"
                                name="description"
                                className="nc-modal-custom-input mb-1 w-full"
                                value={item.description}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                                placeholder="Description"
                              />
                              <SearchBox
                                showSearch
                                value={item.item_id_value}
                                placeholder={"Search Item..."}
                                className="react-select-container w-full"
                                dropdownClassName="z-large antdesign-custom-dropdown"
                                style={antdesignSelectStyle}
                                defaultActiveFirstOption={false}
                                suffixIcon={null}
                                filterOption={false}
                                onSearch={handleSearchItem}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index, "item_id")
                                }
                                notFoundContent={null}
                                options={(allItems || []).map((d) => ({
                                  value: d.value,
                                  label: d.label,
                                }))}
                              />
                              {item.exceed ? <p></p> : ""}
                              {itemError[index] &&
                                itemError[index].description && (
                                  <div className="validity-error callout bottom">
                                    {itemError[index].description}
                                  </div>
                                )}
                            </td>
                            <td className="color-green">
                              {item.item_code}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                name="qty"
                                className="hide-spinner numeric-input"
                                min={1}
                                value={item.qty}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                              />
                              {item.exceed ? (
                                <h7 className="red">Quantity exceeds</h7>
                              ) : (
                                ""
                              )}
                              {itemError[index] && itemError[index].qty && (
                                <div className="validity-error callout bottom">
                                  {itemError[index].qty}
                                </div>
                              )}
                            </td>
                            <td>
                              {item.item_id === "" ||
                              item.item_id === undefined ||
                              item.is_old_item ? (
                                <Form.Control
                                  type="text"
                                  name="unit"
                                  value={item.unit}
                                  className="numeric-input"
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                />
                              ) : (
                                <Form.Select
                                  name="unit"
                                  id={item.id}
                                  value={item.unit_value}
                                  className="numeric-input"
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                >
                                  <option value="">Select</option>
                                  {item.item_units?.map((data) => {
                                    return (
                                      <option
                                        value={data.unit_from + "|" + data.id}
                                      >
                                        {data.unit_from}
                                      </option>
                                    )
                                  })}
                                </Form.Select>
                              )}
                              {item.exceed ? <p></p> : ""}
                            </td>

                            <td>
                              {item.has_item_price ? (
                                <div>
                                  <SearchBox
                                    // showSearch
                                    value={item.priceValue}
                                    placeholder={"Select price..."}
                                    className="react-select-container w-full"
                                    dropdownClassName="z-large antdesign-custom-dropdown"
                                    style={antdesignSelectStyle}
                                    defaultActiveFirstOption={true}
                                    suffixIcon={null}
                                    filterOption={false}
                                    // onSearch={handleSearchItem}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                    options={item.item_prices}
                                    notFoundContent={null}
                                  />
                                  {/* <Select
                                    name="price"
                                    className="react-select-container numeric-input"
                                    classNamePrefix="react-select"
                                    placeholder="Select price..."
                                    value={item.priceValue}
                                    options={item.item_prices}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                  /> */}
                                </div>
                              ) : (
                                <div className="d-flex flex-column">
                                  {/* <SearchBox
                                    showSearch
                                    value={item.priceValue}
                                    placeholder={"Select price..."}
                                    className="react-select-container w-full"
                                    dropdownClassName="z-large antdesign-custom-dropdown"
                                    style={antdesignSelectStyle}
                                    defaultActiveFirstOption={true}
                                    suffixIcon={null}
                                    filterOption={false}
                                    // onSearch={handleSearchItem}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                    options={item.item_prices}
                                    notFoundContent={null}
                                  /> */}
                                  <Form.Control
                                    type="text"
                                    name="price"
                                    className="numeric-input"
                                    value={item.price}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index)
                                    }
                                  />
                                </div>
                              )}
                              {item.exceed ? <p></p> : ""}
                              {itemError[index] && itemError[index].price && (
                                <div className="validity-error callout bottom">
                                  {itemError[index].price}
                                </div>
                              )}
                            </td>
                            <td>
                              <div className="d-flex d-flex-row justify-content-center align-items-center">
                                <Form.Control
                                  type="number"
                                  name="discount"
                                  placeholder={parseFloat(item.unit_discount)}
                                  value={parseFloat(item.discount)}
                                  className="align-middle nc-modal-custom-text hide-spinner numeric-input mb-2 numeric-input"
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index, "discount")
                                  }
                                />
                                <p className="ms-1 fs-6 mt-3">%</p>
                              </div>
                              <div className="d-flex d-flex-row justify-content-center align-items-center">
                                <Form.Control
                                  type="number"
                                  name="discount_amount"
                                  value={item.discount_amount}
                                  className="numeric-input"
                                  disabled
                                />
                                <p className="ms-1 fs-6 mt-3">₱</p>
                              </div>
                            </td>
                            <td className="color-green">
                              {numberFormat(item.subtotal)}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="item_remarks"
                                value={item.item_remarks}
                                className="numeric-input"
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                              />
                              {item.exceed ? <p></p> : ""}
                            </td>

                            <td className="text-center">
                              <img
                                alt="delete"
                                src={trash}
                                onClick={() => deleteOrder(index)}
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div className="entries-not-found">
                    There is no ordered items yet.
                  </div>
                )}
              </div>
              <InputError
                isValid={isError.items}
                message={"Please add an item or additional item"}
              />
            </Col>
          </Row>

          {/* ADD ITEM BUTTON */}
          <Row className="pt-3 PO-add-item">
            <Col xs={12} lg={3}>
              <Button
                type="button"
                disabled={!addDetails.branch_id}
                onClick={() => addNewOrder()}
              >
                Add Item
              </Button>
            </Col>
          </Row>

          {/* SUBTOTAL, FREIGHT COST, DISCOUNT, & GRAND TOTAL */}
          <Fragment>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Subtotal</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle"></span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {numberFormat(addDetails?.subtotal)}
                </span>
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Service Fee</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle"></span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="number"
                  name="service_fee"
                  value={addDetails.service_fee}
                  className="align-middle nc-modal-custom-text hide-spinner numeric-input text-end"
                  onChange={(e) => {
                    handleAddChange(e)
                  }}
                />
              </Col>
            </Row>
            <Row className="align-right py-5">
              <Col xs={7} className="text-end">
                <span className="edit-label color-gray grand-total-text">
                  Grand Total
                </span>
              </Col>
              <Col xs={2} className="text-end">
                <span className="edit-label align-middle grand-total-text"></span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle grand-total-text">
                  {numberFormat(addDetails?.grand_total)}
                </span>
              </Col>
            </Row>
          </Fragment>

          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          <div className="d-flex justify-content-end pt-1 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                {edit ? "Save" : "Submit"}
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default SalesQuotationForm
